import Technexdes from "./Technexdes/Technexdes"
import SeparatorLine from "./SeparatorLine/SeparatorLine"
import TechCardLeft from "./TechCardLeft"
import TechCardRight from "./TechCardRight"
import Technoconudrum from "./TechEventImages/Techno_conundrum.webp"
import fakeInvestor from "./TechEventImages/Fake_Investor.webp"
import explica from "./TechEventImages/Explica.webp"
import "./Technex.css"

function Technex() {
  return (
    <>
      <Technexdes />
      <SeparatorLine />
      <div className="csievents">
        <div className="csievent">
          <TechCardLeft
            imageUrl={Technoconudrum}
            TechTitle="Techno Conundrum"
            // eventAnim={window.innerWidth <= 420 ? "fade-up" : "fade-left"}
            TechDescription="TechnoConundrum is a 2-Day event where you get a fantastic opportunity to showcase your problem-solving and puzzle-tackling skills like a tech-greek. You will get broad exposure to exciting puzzles and questions regarding the latest technological innovations and achievements. This event will initiate the zeal among you to get familiar with scientific investigation, critical thinking, reasoning, and analyzing the given puzzle.."
          />
        </div>
        <div className="csievent">
          <TechCardRight
            imageUrl={explica}
            TechTitle="Explica"
            // eventAnim={window.innerWidth <= 420 ? "fade-up" : "fade-right"}
            TechDescription="Explica is a techno-managathon event in which a team of 2- 3 members have to work out on an on-spot given problem statement. We aim to create a platform to address challenges of today with technologies of tomorrow. It provides a platform to solve some of the pressing problems we face in our daily lives."
          />
        </div>
        <div className="csievent">
          <TechCardLeft
            imageUrl={fakeInvestor}
            TechTitle="Fake Investors"
            // eventAnim={window.innerWidth <= 420 ? "fade-up" : "fade-left"}
            TechDescription="Are you a dumbfounding innovator and have astounding ideas? If yes then, come up with a fabricated idea that would change the course of human development.
            You think you have got all that potential to put an excellent idea in the form of a working model, but waiting for an opportunity... The wait is over now.A wonderful platform where you can improvise your innovative ideas in front of the investment panel.It’s time to think ‘out of the box’."
          />
        </div>
      </div>
    </>
  )
}
export default Technex
